
import { useState } from 'react';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Card } from '../../components/base/Card';
import { Button } from '../../components/base/Button';

export default function PartnersPage() {
  const [activeCategory, setActiveCategory] = useState('Tümü');

  const categories = ['Tümü', 'Çimento & Beton', 'Elektrik', 'Seramik & Banyo', 'Yapı Malzemeleri', 'Isı & Su Yalıtımı'];

  const partners = [
    {
      name: 'Akçansa',
      category: 'Çimento & Beton',
      description: 'Çimento ve hazır beton çözümleri',
      website: 'https://www.akcansa.com.tr',
      logo: 'ri-building-line'
    },
    {
      name: 'Bosch',
      category: 'Elektrik',
      description: 'Elektrik ve otomasyon sistemleri',
      website: 'https://www.bosch.com.tr',
      logo: 'ri-flashlight-line'
    },
    {
      name: 'Vitra',
      category: 'Seramik & Banyo',
      description: 'Seramik ve banyo ürünleri',
      website: 'https://www.vitra.com.tr',
      logo: 'ri-drop-line'
    },
    {
      name: 'Kale',
      category: 'Yapı Malzemeleri',
      description: 'Yapı kimyasalları ve seramik',
      website: 'https://www.kale.com.tr',
      logo: 'ri-hammer-line'
    },
    {
      name: 'Schneider Electric',
      category: 'Elektrik',
      description: 'Elektrik dağıtım ve otomasyon',
      website: 'https://www.schneider-electric.com.tr',
      logo: 'ri-plug-line'
    },
    {
      name: 'Grohe',
      category: 'Seramik & Banyo',
      description: 'Premium banyo ve mutfak armatürleri',
      website: 'https://www.grohe.com.tr',
      logo: 'ri-water-flash-line'
    },
    {
      name: 'Ytong',
      category: 'Yapı Malzemeleri',
      description: 'Gazbeton ve yapı malzemeleri',
      website: 'https://www.ytong.com.tr',
      logo: 'ri-building-2-line'
    },
    {
      name: 'Sika',
      category: 'Isı & Su Yalıtımı',
      description: 'Yapı kimyasalları ve yalıtım',
      website: 'https://www.sika.com.tr',
      logo: 'ri-shield-line'
    },
    {
      name: 'Siemens',
      category: 'Elektrik',
      description: 'Endüstriyel otomasyon ve elektrik',
      website: 'https://www.siemens.com.tr',
      logo: 'ri-cpu-line'
    },
    {
      name: 'Eczacıbaşı',
      category: 'Seramik & Banyo',
      description: 'Seramik ve banyo grubu ürünleri',
      website: 'https://www.eczacibasi.com.tr',
      logo: 'ri-home-line'
    },
    {
      name: 'İzocam',
      category: 'Isı & Su Yalıtımı',
      description: 'Isı ve ses yalıtım malzemeleri',
      website: 'https://www.izocam.com.tr',
      logo: 'ri-temp-cold-line'
    },
    {
      name: 'Baumit',
      category: 'Yapı Malzemeleri',
      description: 'Dış cephe sistemleri ve sıvalar',
      website: 'https://www.baumit.com.tr',
      logo: 'ri-paint-brush-line'
    }
  ];

  const filteredPartners = activeCategory === 'Tümü' 
    ? partners 
    : partners.filter(partner => partner.category === activeCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-24 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-[28px] font-bold text-[#0e3851] mb-4">
              Çözüm Ortaklarımız
            </h1>
            <p className="text-[16px] text-gray-600 max-w-3xl mx-auto">
              Güvenilir markalarla işbirliği yaparak projelerimizde 
              en kaliteli malzemeleri kullanıyoruz
            </p>
          </div>
        </div>
      </section>

      {/* Kategori Filtreleri */}
      <section className="py-8 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-6 py-2 rounded-full text-[14px] font-medium transition-all duration-200 whitespace-nowrap ${
                  activeCategory === category
                    ? 'bg-[#0e3851] text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Ortaklar Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredPartners.map((partner, index) => (
              <Card key={index} hover className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-gray-100 rounded-2xl mx-auto mb-4 grayscale hover:grayscale-0 transition-all duration-300">
                  <i className={`${partner.logo} text-[24px] text-gray-600`}></i>
                </div>
                <h3 className="text-[16px] font-semibold text-[#0e3851] mb-2">
                  {partner.name}
                </h3>
                <p className="text-[12px] text-gray-500 mb-2">
                  {partner.category}
                </p>
                <p className="text-[14px] text-gray-600 mb-4">
                  {partner.description}
                </p>
                <a 
                  href={partner.website}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="inline-flex items-center text-[14px] text-[#0e3851] hover:text-[#0c2f44] transition-colors"
                >
                  <i className="ri-external-link-line mr-1"></i>
                  Web Sitesi
                </a>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Ortaklık Avantajları */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-[22px] font-semibold text-[#0e3851] mb-4">
              Neden Bu Markalarla Çalışıyoruz?
            </h2>
            <p className="text-[15px] text-gray-600 max-w-2xl mx-auto">
              Kaliteli projeler için güvenilir ortaklarla çalışmanın avantajları
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-[#0e3851] rounded-xl mx-auto mb-4">
                <i className="ri-award-line text-[20px] text-white"></i>
              </div>
              <h3 className="text-[16px] font-semibold text-[#0e3851] mb-2">Kalite Garantisi</h3>
              <p className="text-[14px] text-gray-600">
                Uluslararası standartlarda kaliteli ürünler
              </p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-[#0e3851] rounded-xl mx-auto mb-4">
                <i className="ri-time-line text-[20px] text-white"></i>
              </div>
              <h3 className="text-[16px] font-semibold text-[#0e3851] mb-2">Zamanında Teslimat</h3>
              <p className="text-[14px] text-gray-600">
                Güvenilir tedarik zinciri ile kesintisiz çalışma
              </p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-[#0e3851] rounded-xl mx-auto mb-4">
                <i className="ri-customer-service-line text-[20px] text-white"></i>
              </div>
              <h3 className="text-[16px] font-semibold text-[#0e3851] mb-2">Teknik Destek</h3>
              <p className="text-[14px] text-gray-600">
                Uzman ekiplerden sürekli teknik destek
              </p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center bg-[#0e3851] rounded-xl mx-auto mb-4">
                <i className="ri-leaf-line text-[20px] text-white"></i>
              </div>
              <h3 className="text-[16px] font-semibold text-[#0e3851] mb-2">Çevre Dostu</h3>
              <p className="text-[14px] text-gray-600">
                Sürdürülebilir ve çevre dostu ürünler
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#0e3851] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-[22px] font-semibold mb-4">
            Kaliteli Malzemelerle Projenizi Hayata Geçirin
          </h2>
          <p className="text-[16px] text-gray-300 mb-8">
            Güvenilir ortaklarımızın kaliteli ürünleriyle projenizi gerçekleştirmek için 
            bizimle iletişime geçin.
          </p>
          <Button size="lg" className="bg-white text-[#0e3851] hover:bg-gray-100">
            <i className="ri-phone-line mr-2"></i>
            Proje Danışmanlığı Al
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
